import { Link } from "react-router-dom";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useI18n } from "@/i18n/I18nProvider";
import { LANGS } from "@/i18n/translations";
import { Logo } from "@/components/Logo";
import { trackEvent } from "@/lib/track";

export const Navbar = () => {
  const { t, lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const current = LANGS.find((l) => l.code === lang)!;

  const links = [
    { href: "/#styles", label: t("nav.styles") },
    { href: "/#pricing", label: t("nav.pricing") },
    { href: "/#reviews", label: t("nav.reviews"), hideOnMobile: true },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-background/70 border-b border-border/40">
      <div className="container flex h-16 items-center justify-between gap-2">
        <Logo />


        <nav className="flex items-center gap-3 sm:gap-5 md:gap-8 text-xs sm:text-sm ml-auto mr-2 sm:mr-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`font-semibold text-foreground/90 hover:text-neon-purple transition-colors drop-shadow-[0_0_8px_hsl(var(--neon-purple)/0.6)] hover:drop-shadow-[0_0_12px_hsl(var(--neon-purple))] ${l.hideOnMobile ? "hidden sm:inline" : ""}`}
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/blog"
            className="font-semibold text-foreground/90 hover:text-neon-purple transition-colors drop-shadow-[0_0_8px_hsl(var(--neon-purple)/0.6)] hover:drop-shadow-[0_0_12px_hsl(var(--neon-purple))]"
          >
            Blog
          </Link>
        </nav>

        <div className="flex items-center gap-2">
          <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="sm"
                aria-label={`Change language — current: ${current.label}`}
                className="gap-2 font-bold text-gold hover:text-gold hover:bg-gold/10 drop-shadow-[0_0_8px_hsl(var(--gold)/0.7)]"
              >
                <span className="hidden sm:inline">{current.flag} {current.short}</span>
                <span className="sm:hidden">{current.flag}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-card/95 backdrop-blur border-border">
              {LANGS.map((l) => (
                <DropdownMenuItem key={l.code} onClick={() => setLang(l.code)} className="gap-3 cursor-pointer">
                  <span className="text-lg">{l.flag}</span>
                  <span>{l.label}</span>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>

          <Button asChild size="sm" className="hidden md:inline-flex bg-neon-green text-background hover:bg-neon-green/90 font-semibold">
            <a href="#upload" onClick={() => trackEvent("try-now")}>{t("nav.cta")}</a>
          </Button>
        </div>
      </div>
    </header>
  );
};
